import { render, staticRenderFns } from "./AreaEmbargada.vue?vue&type=template&id=4c15e5c0&scoped=true&lang=pug"
import script from "./AreaEmbargada.vue?vue&type=script&lang=js"
export * from "./AreaEmbargada.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargada.vue?vue&type=style&index=0&id=4c15e5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15e5c0",
  null
  
)

export default component.exports